import { Injectable } from '@angular/core';

import { LanguageModel } from '../../../Core/Localization/models/language.model';
import { LocalizationService } from '../../../Core/Localization/services/localization.service';
import { LanguageSelectDialogService } from '../../../Common/Dialogs/services/language-select-dialog.service';
import { IncludeOrExclude } from '../../../Common/Dialogs/services/data-select-dialog.service.interface';

/**
 * This service is the implementation of the interface for the DataSelectDialogComponent.
 *
 * It defines the logic for handling the selection and removal of languages models to either the include or exclude
 * languages on the MonitoringSearchQuery.
 */
@Injectable()
export class MonitoringSearchLanguageSelectDialogService extends LanguageSelectDialogService {

    constructor(
        protected localizationService: LocalizationService,
    ) {
        super(localizationService);
    }

    /**
     * Sets the appropriate list items for the services state
     */
    public setAppropriateListItems(): void {
        if (!this.state) {

            return;
        }

        this.selectedListItems = this.mapSelectedLanguagesToNodes(this.selectedLanguages);
        this.selectedDataItems = this.selectedListItems;
        this.updateSelectedTypes();
        this.selectedListItemProvider.next(this.selectedListItems);
        this.selectedDataItemsProvider.next(this.selectedDataItems);
    }

    /**
     * Applies the selected languages to the search query
     */
    public applySelectedListItems(): void {
        this.selectedLanguages = [];
        for (const selectedItem of this.selectedListItems) {
            this.selectedLanguages.push(<LanguageModel>selectedItem.data);
        }
    }

    prepareModelData(state: IncludeOrExclude, languages: LanguageModel[]) {
        this.selectedLanguages = languages;
        this.setState(state);
    }
}
